import { Injectable } from '@angular/core';
import { GoogleConversionTagComponent } from '../components/google-conversion-tag/google-conversion-tag.component';
import { GooglePatternNumberFormatter } from './google-pattern-number-formatter';

export interface PurchaseItem {
    id: string;
    name: string;
    category: string;
    quantity: number;
    price: string;
    unit_price: string;
}

@Injectable()
export class GoogleGtagService {
    protected hasGoogleConversionId = false;
    protected googleAnalyticsAccount = null;

    constructor(protected googlePatternNumberFormatter: GooglePatternNumberFormatter) {
    }

    /**
     * Send purchase data event to Google gtag service.
     **/
    public purchase(
        transactionId: string,
        subtotal: string,
        otherCosts: string,
        freight: string,
        items: Array<PurchaseItem>
    ) {
        if (!window.hasOwnProperty('gtag')) {
            console.warn(
                'Checkout -> gtag is not configured to send purchase data'
            );
            return false;
        }

        const data = {
            'transaction_id': transactionId,
            'affiliation': window.location.hostname,
            'revenue': parseFloat(parseFloat(subtotal).toFixed(2)),
            'value': parseFloat(parseFloat(subtotal).toFixed(2)),
            'currency': 'BRL',
            'tax': parseFloat(parseFloat(otherCosts).toFixed(2)),
            'shipping': parseFloat(parseFloat(freight).toFixed(2)),
            'items': items
        };

        // Send event for Betalabs if Google Analytics account is not set
        if (this.googleAnalyticsAccount === null || this.hasGoogleConversionId) {
            const betalabsData = { ...data, 'send_to': 'G-29TE1B8ZRK' };
            console.log('Event purchase Betalabs', betalabsData);
            window['gtag']('event', 'purchase', betalabsData);

            // Stop processing if Google Conversion ID is configured
            if (this.hasGoogleConversionId) {
                // Has configured google conversion id so transaction will be
                // sent by GoogleConversionTagComponent.
                return false;
            }
        }

        // Send event to Google Analytics account if it exists
        if (this.googleAnalyticsAccount !== null) {
            const gaData = { ...data, 'send_to': this.googleAnalyticsAccount };
            console.log('Event purchase', gaData);
            window['gtag']('event', 'purchase', gaData);
        }
    }

    public setHasGoogleConversionId(hasGoogleConversionId: boolean) {
        this.hasGoogleConversionId = hasGoogleConversionId;

        return this;
    }
    
    public setGoogleConversionAccount(googleConversionAccount = null) {
        console.log(googleConversionAccount);
        this.googleAnalyticsAccount = googleConversionAccount;
        return this;
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src727013012/src/src/app/shared/services/google.gtag.service.ts